var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"phoneCall",on:{"click":function($event){return _vm.$emit('click')}}},[_c('phoneIcon',{staticClass:"phoneCall__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }